/* カートの「メッセージカード・のし」欄（くろ 2026-10-11）
   ・注文で見えるのは備考（メモ、#CartSpecialInstructions）1か所だけ。宛名・メッセージ・差出人・のしをまとめて書く
   ・カート属性は「_」付きの名前で、カートの入力を残すためだけに使う（管理画面・チェックアウトには出ない）
   ・gift-wrapping.js はラッピングの行に「_ご注文についての備考」として写す（これも管理画面には出ない） */
(function () {
  'use strict';
  var NOTE_ID = 'CartSpecialInstructions';
  var LEGACY = ['メッセージカード', 'カード 宛名', 'カード メッセージ', 'カード 差出人', 'のし', 'のし 表書き', 'のし お名前'];
  var KEYS = ['_メッセージカード', '_カード 宛名', '_カード メッセージ', '_カード 差出人', '_のし', '_のし 表書き', '_のし お名前'];

  function val(box, key) {
    var el = box.querySelector('[name="attributes[' + key + ']"]:checked') ||
      box.querySelector('[name="attributes[' + key + ']"]:not([type=radio])');
    return el ? String(el.value || '').trim() : '';
  }

  function collect(box) {
    var card = val(box, '_メッセージカード') === '付ける';
    var noshi = val(box, '_のし') === '付ける';
    var a = {};
    a['_メッセージカード'] = card ? '付ける' : '付けない';
    a['_カード 宛名'] = card ? val(box, '_カード 宛名') : '';
    a['_カード メッセージ'] = card ? val(box, '_カード メッセージ') : '';
    a['_カード 差出人'] = card ? val(box, '_カード 差出人') : '';
    a['_のし'] = noshi ? '付ける' : '付けない';
    a['_のし 表書き'] = noshi ? val(box, '_のし 表書き') : '';
    a['_のし お名前'] = noshi ? val(box, '_のし お名前') : '';
    // 以前の名前（「_」なし）は管理画面に出てしまうので、空にして消す
    LEGACY.forEach(function (k) { a[k] = ''; });
    return a;
  }

  function compose(a) {
    var lines = [];
    if (a['_メッセージカード'] === '付ける') {
      lines.push('メッセージカード：付ける');
      lines.push('宛名：' + (a['_カード 宛名'] ? a['_カード 宛名'] + ' 様' : '（なし）'));
      lines.push('メッセージ：' + (a['_カード メッセージ'] || '（なし）'));
      lines.push('差出人：' + (a['_カード 差出人'] || '（なし）'));
    } else {
      lines.push('メッセージカード：なし');
    }
    if (a['_のし'] === '付ける') {
      lines.push('のし：' + a['_のし 表書き'] + '／名入れ ' + (a['_のし お名前'] || 'なし'));
    } else {
      lines.push('のし：なし');
    }
    return lines.join('\n');
  }

  var timer = null;
  var mirrorWanted = false;
  var pendingSave = null; // 0.7秒待ちの保存（お会計ボタンが押されたら取り消す）
  // mirror=true のときだけ、保存のあとでラッピングの行にも写す（入力中の1文字ごとには写さない）
  function save(box, mirror) {
    if (mirror) mirrorWanted = true;
    var a = collect(box);
    var text = compose(a);
    var note = document.getElementById(NOTE_ID);
    // 備考の欄は先に書き換えておく（お会計ボタンで送られる値をそろえる）
    if (note) note.value = text;
    clearTimeout(timer);
    pendingSave = function () {
      pendingSave = null;
      // 追加の詳細と備考を1回で保存する（別々に同時に送ると、片方が消えることがある）
      return fetch(((window.theme && window.theme.routes && window.theme.routes.cart_update_url) || '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: a, note: text }),
        keepalive: true
      }).catch(function () {}).then(function () {
        // 欄を離れたとき・ボタンを選んだときは、保存のあとで gift-wrapping.js にラッピングの行へ写してもらう
        // （お会計のときは gift-wrapping.js が最後にもう一度写す）
        if (!mirrorWanted) return;
        mirrorWanted = false;
        var n = document.getElementById(NOTE_ID);
        if (n) n.dispatchEvent(new Event('input', { bubbles: true }));
      });
    };
    timer = setTimeout(function () { if (pendingSave) pendingSave(); }, 700);
  }

  // お会計ボタン：待っている保存は取り消す。
  // gift-wrapping.js がお会計の前に備考と一緒に追加の詳細（window.KuroGift.attributes）も1回で保存する。
  // gift-wrapping.js が止めないときは、フォームの送信で入力がそのまま送られる。
  document.addEventListener('submit', function (event) {
    var f = event.target;
    var isCheckout = (event.submitter && event.submitter.name === 'checkout') ||
      (f && f.id && document.querySelector('[name="checkout"][form="' + f.id + '"]'));
    if (!isCheckout) return;
    clearTimeout(timer);
    pendingSave = null;
    mirrorWanted = false;
  }, true);

  window.KuroGift = {
    // 今の選択（カート属性の形）。ギフト欄がないページでは null
    attributes: function () {
      var box = document.querySelector('[data-kuro-gift]');
      return box ? collect(box) : null;
    }
  };

  function refresh(box) {
    var card = val(box, '_メッセージカード') === '付ける';
    var noshi = val(box, '_のし') === '付ける';
    [['[data-kuro-card]', card], ['[data-kuro-noshi]', noshi]].forEach(function (p) {
      var wrap = box.querySelector(p[0]);
      if (!wrap) return;
      wrap.hidden = !p[1];
      // 「付けない」のときは中の欄を送らない
      wrap.querySelectorAll('input,textarea,select').forEach(function (el) { el.disabled = !p[1]; });
    });
    var body = box.querySelector('[name="attributes[_カード メッセージ]"]');
    var count = box.querySelector('[data-kuro-count]');
    if (body && count) {
      var n = body.value.replace(/\s/g, '').length;
      count.textContent = n + '／100字';
      count.classList.toggle('is-over', n > 100);
    }
  }

  function setup(box) {
    if (box.hasAttribute('data-ready')) return;
    box.setAttribute('data-ready', '');
    refresh(box);
    box.addEventListener('change', function () { refresh(box); save(box, true); });
    box.addEventListener('input', function () { refresh(box); save(box, false); });
    // 最初に開いたときも、備考を今の選択に合わせる
    var note = document.getElementById(NOTE_ID);
    if (note && note.value !== compose(collect(box))) save(box, true);
  }

  // PC幅（1068px〜）ではギフト欄を左の列（商品の下）へ移し、スマホでは右の列（元の場所）に戻す
  var wide = window.matchMedia('(min-width: 1068px)');
  function place() {
    var row = document.querySelector('.cart-note-row');
    var slot = document.querySelector('[data-kuro-gift-slot]');
    var home = document.querySelector('[data-kuro-gift-home]');
    if (!row || !slot || !home) return;
    if (wide.matches) {
      if (row.parentNode !== slot) slot.appendChild(row);
    } else if (home.nextElementSibling !== row) {
      home.parentNode.insertBefore(row, home.nextSibling);
    }
  }
  if (wide.addEventListener) wide.addEventListener('change', place);
  else if (wide.addListener) wide.addListener(place);

  function scan() {
    document.querySelectorAll('[data-kuro-gift]:not([data-ready])').forEach(setup);
    place();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
